import {stringify} from 'qs'
import request from 'crm/utils/request'
import api from 'crm/common/api/drainage-channel-stat'

// 渠道统计-列表
export async function getTableData(params) {
    return request(`${api.getTableData.url}?${stringify(params)}`)
}

// 渠道统计-摘要
export async function getStat(params) {
    return request(`${api.getStat.url}?${stringify(params)}`)
}

// 基本的导出
export async function exportExcel(params) {
    return request(`${api.exportExcel.url}?${stringify(params)}`, null, {
        returnResponse: true,
    })
}

// 大名创的导出
export async function mainMinisoExportExcel(params) {
    return request(`${api.mainMinisoExportExcel.url}?${stringify(params)}`, null, {
        returnResponse: true,
    })
}

// 渠道统计-明细-日期统计
export async function detailStatByDate(params) {
    return request(`${api.detailStatByDate.url}?${stringify(params)}`)
}

// 渠道统计-明细-时间段统计
export async function detailStatByHour(params) {
    return request(`${api.detailStatByHour.url}?${stringify(params)}`)
}
